import * as React from "react";
const SvgCapacity = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M12 6.16667V12L7.875 16.125C8.93083 17.1808 10.3892 17.8333 12 17.8333C15.2217 17.8333 17.8333 15.2217 17.8333 12C17.8333 8.77833 15.2217 6.16667 12 6.16667ZM12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 6.4775 17.5225 2 12 2ZM12 19.5C7.85833 19.5 4.5 16.1417 4.5 12C4.5 7.8575 7.85833 4.5 12 4.5C16.1425 4.5 19.5 7.8575 19.5 12C19.5 16.1417 16.1425 19.5 12 19.5Z",
	fill: "#546E7A"
}));
export default SvgCapacity;
